<template>
  <el-table
    ref="table"
    :data="tableData"
    style="width: 100%"
    border
    :empty-text="empty"
    @cell-click="handleRowClick"
  >
    <el-table-column
      v-for="(item, index) in thead"
      :key="index"
      :prop="tpropty[index]"
      align="center"
      :resizable="false"
      :label="item.label || item"
      :width="item.width"
    >
      <template slot-scope="scope">
        <span
          v-if="isShowBtns && tpropty[index] === 'btns'"
          :title="scope.row.isBtnCount ? '' : '暂不支持查看审读报告'"
          :class="['btns', { 'btns-disabled': !scope.row.isBtnCount }]"
        >
          查看审读报告
        </span>
        <!-- 互联网数据查看原文链接 -->
        <a
          v-else-if="
            isShowBtns &&
              tpropty[index] === 'title' &&
              String(scope.row.system) === '1'
          "
          :title="scope.row[tpropty[index]]"
          :href="scope.row.location"
          target="_blank"
        >
          {{ scope.row[tpropty[index]] }}
        </a>
        <span
          v-else
          :title="scope.row[tpropty[index]]"
          :class="[
            tpropty[index],
            { 'disabled':scope.row[tpropty[index]]===0},
            { manual:
              isReviewTable &&
              String(scope.row.offset) === '0' &&
              String(scope.row.paragraphIndex) === '0' &&
              (index == 2 || index == 3)}
          ]"
        >{{ scope.row[tpropty[index]] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'Jgsdtable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    thead: {
      type: Array,
      default: () => []
    },
    tpropty: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: '暂无数据'
    },
    isReviewTable: {
      type: Boolean,
      default: false
    },
    isShowBtns: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleRowClick(row, column) {
      this.$emit(
        'handleRowClick',
        Object.assign({}, row, { prop: column.property })
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  border-color: #dcdcdc;
  /deep/ &__header {
    &-wrapper {
      th {
        text-align: center;
        padding: 0;
        font-size: 13px;
        height: 32px;
        background: #f5f5f5;
        color: #333;
        border-color: #dcdcdc;
        font-weight: normal;
      }
    }
  }
  /deep/ &__body {
    tr {
      &:hover {
        td {
          color: #454647;
        }
      }
      td {
        height: 32px;
        font-size: 12px;
        color: #454647;
        text-align: center;
        border-color: #dcdcdc;
        .cell {
          @extend .ellipsis;
          span.manual {
            color: #454647;
            cursor: auto;
          }
          a{
            color:#4497ec;
          }
          span.btns {
            color: #4497ec;
            cursor: pointer;
            text-decoration: underline;
            &.btns-disabled {
              color: #999;
              cursor: auto;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
}
</style>
